import { useEffect, useRef, useState } from 'react';
import './SettingsRolesAndPerm.scss';
import Dropdown from '../../components/Dropdown/Dropdown';
import { LuMoreVertical } from 'react-icons/lu';
import { useOutsideClick } from '../../helpers/utils';
import trashIcon from '../../assets/icons/trashg.svg';
import upgradeIcon from '../../assets/icons/upgrade.svg';
import ModalAdminAction from '../../components/Modals/ModalAdminAction';
import ModalExecuteAction from '../../components/Modals/ModalExecuteAction';
import useRolePermissions from '../../hooks/useRolePermissions';
import { authPayload } from '../../helpers/utils/auth-payload';

import ViewRolesMatrix from './ViewRolesMatrix';
import { Loader } from '@piggytechng/component-library';
import ModalSearch from '../../components/Modals/ModalSearch';

const SettingsUserPermission = ({
  action,
}: {
  action: null | { type: 'invite' | 'view-roles'; timeStamp: number; payload?: any };
}) => {
  const [ppDetails, setPPDetails] = useState<null | any>(null);
  const [modalInviteAction, showModalInviteAction] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [showRolesMatrix, setShowRolesMatrix] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const {
    AllAdmins,
    removeAdmin,
    isLoading,
    fetchAllAdmins,
    nextCursor,
    setNextCursor,
    canResetSearch,
    AdminParams,
    setAdminParams,
  } = useRolePermissions({});

  const [actionType, setActionType] = useState<'invite' | 'edit' | 'remove' | ''>('');
  const [key, setKey] = useState(0);

  useEffect(() => {
    fetchAllAdmins();
  }, []);

  const [showDropdown, setShowDropdown] = useState({
    index: -1,
    show: false,
  });

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  const dropdownArray = [
    {
      icon: <img src={upgradeIcon} alt="" />,
      text: 'Edit Admin',
      fn: () => {
        setKey((prev) => prev + 1);
        setActionType('edit');
      },
    },

    {
      icon: <img src={trashIcon} alt="" />,
      text: 'Remove Admin',
      fn: () => {
        setKey((prev) => prev + 1);
        setActionType('remove');
      },
    },
  ];

  const handleAction = (password?: string, callback?: () => void) => {
    if (actionType === 'remove') {
      removeAdmin({
        status: false,
        userId: ppDetails?.userId,
        ...authPayload(password ?? ''),
      }).finally(() => {
        setShowActionModal(false);
        if (callback) callback();
      });
      return;
    }
    setActionType('');
  };

  const [execution, setExecution] = useState<{
    text: string;
    action: (password: string) => void;
    actionColor: string;
    buttonText: string;
  }>({
    text: 'delete this account?',
    action: (password: string) => handleAction(password),
    actionColor: '',
    buttonText: 'Yes',
  });

  useEffect(() => {
    if (actionType === 'edit') {
      showModalInviteAction(true);
    } else if (actionType === 'remove') {
      setExecution({
        text: `remove this admin account?`,
        action: (password: string) => handleAction(password),
        actionColor: '#DC3545',
        buttonText: 'Remove',
      });
      setShowActionModal(true);
    }
  }, [actionType, key]);

  const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
    e.stopPropagation();
    if (i === showDropdown.index) {
      setShowDropdown({ ...showDropdown, show: false, index: -1 });
    } else {
      setShowDropdown({ ...showDropdown, show: true, index: i });
    }

    setPPDetails(AllAdmins[i]);
  };

  useEffect(() => {
    if (action) {
      if (action.type === 'invite') {
        setPPDetails(null);
        setActionType('invite');
        showModalInviteAction(true);
      } else if (action.type === 'view-roles') {
        setShowRolesMatrix(true);
      }
    }
  }, [action]);

  return (
    <div className="settings-roles-and-permissions">
      <div className="header">
        <h5>Admins</h5>
      </div>

      {isLoading.isLoadingAdmins ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <>
          <div className="customers-filter">
            <div className="input-field" onClick={() => setFilterModal(true)}>
              <input
                type="text"
                placeholder="Search admin by user ID, email or phone number"
                value={AdminParams.value}
              />
            </div>
            {canResetSearch && (
              <div className="query-filter" onClick={() => fetchAllAdmins(undefined, true)}>
                <div></div>
                <div>Reset</div>
              </div>
            )}
          </div>

          <div className="table-container  admins-role-list">
            <table className="table">
              <thead className="table_head">
                <tr>
                  <th className="id">ID</th>
                  <th className="name"> Name</th>
                  <th className="email">Email</th>
                  <th className="role">Role</th>
                  <th className="phone">Phone</th>
                  <th className="action"></th>
                </tr>
              </thead>

              <tbody className="table-body">
                {AllAdmins?.map((admin: any, i: number) => {
                  return (
                    <tr key={admin.name} className="table-row">
                      <td className="id">{admin.userId}</td>
                      <td className="name">
                        {admin.firstname} {admin.lastname}
                      </td>
                      <td className="email">{admin.email}</td>
                      <td className="role">{admin.roleName || 'N/A'}</td>
                      <td className="phone">{admin.phone}</td>

                      <td className="action">
                        <div className="dropdown-container" ref={actionRef}>
                          <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                            <LuMoreVertical color="#CBD5E1" size={25} />
                          </button>

                          {showDropdown.index === i && showDropdown.show && (
                            <div className="table-dropdown" ref={dropdownRef}>
                              <Dropdown data={dropdownArray} index={i} />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}

      {nextCursor && !AdminParams.value && (
        <div
          className="load-more"
          onClick={() => fetchAllAdmins({ isLoadingMoreAdmins: true, cursor: nextCursor })}
          style={{ marginTop: '0px', transform: 'translateY(-50px)' }}
        >
          {isLoading.isLoadingMoreAdmins ? (
            <Loader color="#0F60D6" maxWidth="50px" />
          ) : (
            <span className="pointer">Show more</span>
          )}
        </div>
      )}

      <ModalAdminAction
        modalIsOpen={modalInviteAction}
        data={ppDetails}
        isLoading={isLoading.isInvitingAdmin || isLoading.isEditingAdmin}
        setIsOpen={showModalInviteAction}
        type={actionType}
        action={() => {
          setActionType('');
          showModalInviteAction(false);
        }}
      />

      <ViewRolesMatrix onClose={() => setShowRolesMatrix(false)} show={showRolesMatrix} />

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading.isRemovingAdmin || isLoading.isInvitingAdmin || isLoading.isEditingAdmin}
        setIsOpen={setShowActionModal}
        {...execution}
      />

      <ModalSearch
        modalIsOpen={filterModal}
        searchContext="search-admins"
        data={AdminParams}
        setIsOpen={setFilterModal}
        searchDataBy={(filter, empty) => {
          const params = {
            ...AdminParams,
            ...filter.admins,
          };
          setAdminParams(params);
          if (!empty) {
            setNextCursor(null);
            fetchAllAdmins({ ...params, isLoadingMoreAdmins: false, cursor: '' });
          }
        }}
      />
    </div>
  );
};

export default SettingsUserPermission;
